import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "main-content",
  style: {"overflow-y":"none"}
}
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_6 = { class: "col-md-4 d-flex justify-content-start py-4" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  class: "font-size-16 font-grey p-cursor",
  onclick: "location.href='https://map.admin.caprock.com.au/edit-customer/54?type=view'"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"35px","margin":"0 15px"},
  src: "https://map.admin.caprock.com.au/inlancer-admin/images/users-sqr.svg"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  style: {"color":"#6B7A99"}
}
const _hoisted_11 = {
  key: 1,
  style: {"color":"#6B7A99"}
}
const _hoisted_12 = { class: "col-md-6 d-flex justify-content-center align-items-center py-4" }
const _hoisted_13 = { class: "nav justify-content-center" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Profile", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "External Banks", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Managing Members", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Beneficial Owners", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey active" }, "Accounts", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 d-flex justify-content-end align-items-center py-4" }, null, -1)
const _hoisted_30 = {
  class: "tab-pane fade show active",
  id: "pills-profile",
  role: "tabpanel",
  "aria-labelledby": "pills-currency-tab"
}
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "row mt-5 mx-1 p-3 bg-white border-radius-10" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mt-5 mx-1" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-16" }, "Active Accounts")
], -1)
const _hoisted_35 = { class: "col-md-12 row mb-5 pb-5 mx-1" }
const _hoisted_36 = { class: "col-md-12 mt-4 pt-2 d-flex justify-content-start align-items-center" }
const _hoisted_37 = {
  width: "100%",
  class: "table table-striped"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 0,
  class: "mainItem"
}
const _hoisted_40 = { width: "5%" }
const _hoisted_41 = { class: "font-grey" }
const _hoisted_42 = { class: "font-grey text-right" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, "No accounts found ...")
], -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "row mt-5 mx-1 p-3 bg-white border-radius-10" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mt-5 mx-1" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-16" }, "Archived Accounts")
], -1)
const _hoisted_49 = { class: "col-md-12 row mb-5 pb-5 mx-1" }
const _hoisted_50 = { class: "col-md-12 mt-4 pt-2 d-flex justify-content-start align-items-center" }
const _hoisted_51 = {
  width: "100%",
  class: "table table-striped"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 0,
  class: "mainItem"
}
const _hoisted_54 = { width: "5%" }
const _hoisted_55 = { class: "font-grey" }
const _hoisted_56 = { class: "font-grey text-right" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, "No accounts found ...")
], -1)
const _hoisted_59 = [
  _hoisted_58
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createElementVNode("h5", _hoisted_8, [
                    _hoisted_9,
                    (_ctx.user_info.u_type!=2)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_10, _toDisplayString(_ctx.user_info.user_name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.user_info.u_type==2)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_11, _toDisplayString(_ctx.user_info.user_company_name), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", _hoisted_14, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      "aria-current": "page",
                      href: "javascript:;",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/my-profile')))
                    }, _hoisted_16)
                  ]),
                  _createElementVNode("li", _hoisted_17, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      "aria-current": "page",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/bank-accounts'))),
                      href: "javascript:;"
                    }, _hoisted_19)
                  ]),
                  (_ctx.user_info.is_directors==1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          "aria-current": "page",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/managing-members'))),
                          href: "javascript:;"
                        }, _hoisted_22)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.user_info.is_owners==1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          "aria-current": "page",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/beneficial-owners'))),
                          href: "javascript:;"
                        }, _hoisted_25)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_26, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      href: "javascript:;",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/my-accounts')))
                    }, _hoisted_28)
                  ])
                ])
              ]),
              _hoisted_29
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("table", _hoisted_37, [
                          (_ctx.customer_accounts.length)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: ac.userac_id,
                                    class: "mb-2"
                                  }, [
                                    (ac.userac_status==1)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                                          _createElementVNode("th", _hoisted_40, [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle([{'background':ac.ac_color}, {"padding":"0px 12px"}]),
                                              class: "account-icon"
                                            }, null, 4)
                                          ]),
                                          _createElementVNode("td", _hoisted_41, _toDisplayString(ac.ac_name), 1),
                                          _createElementVNode("td", _hoisted_42, _toDisplayString(ac.default_currency_icon) + " " + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.customer_accounts.length)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_43, _hoisted_45))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("table", _hoisted_51, [
                          (_ctx.customer_accounts.length)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_52, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: ac.userac_id,
                                    class: "mb-2"
                                  }, [
                                    (ac.userac_status==2)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                                          _createElementVNode("th", _hoisted_54, [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle([{'background':ac.ac_color}, {"padding":"0px 12px"}]),
                                              class: "account-icon"
                                            }, null, 4)
                                          ]),
                                          _createElementVNode("td", _hoisted_55, _toDisplayString(ac.ac_name), 1),
                                          _createElementVNode("td", _hoisted_56, _toDisplayString(ac.default_currency_icon) + " " + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.customer_accounts.length)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_57, _hoisted_59))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}